(function () {
  'use strict';

  if (
    location.pathname === '/' &&
    location.search.indexOf('view=__DEFAULT__') !== -1
  ) {
    location.replace('/?view=live' + location.hash);
    return;
  }

  function ensureCollectionPageVisible() {
    var main = document.querySelector('main[data-template="collection"]');
    if (!main) return;

    if (!document.getElementById('nuvra-collection-fix-css')) {
      var marker = document.querySelector('link[href*="nuvra-marketplace.css"]');
      var href = marker
        ? marker.href.replace('nuvra-marketplace.css', 'nuvra-collection-fix.css')
        : '/cdn/shop/t/8/assets/nuvra-collection-fix.css';
      var link = document.createElement('link');
      link.id = 'nuvra-collection-fix-css';
      link.rel = 'stylesheet';
      link.href = href;
      document.head.appendChild(link);
    }

    document.querySelectorAll('.nuvra-mp-collection-section .nuvra-reveal').forEach(function (el) {
      el.classList.add('is-visible');
      el.style.opacity = '1';
      el.style.transform = 'none';
    });

    document.body.style.background = '#0a0a0a';
    var layout = document.querySelector('.content-for-layout');
    if (layout) layout.style.background = '#0a0a0a';
  }

  function applyGuestHubTab(tab, studioBase) {
    var guestLabel = tab.dataset.hubGuestLabel || tab.dataset.sellGuestLabel || 'Sell with Nuvra';
    var guestShort = tab.dataset.hubGuestShort || tab.dataset.sellGuestShort || 'Sell';
    var guestHref =
      tab.dataset.hubGuestHref || tab.dataset.sellGuestHref || '/?view=build-my-shop';
    tab.href = guestHref;
    tab.setAttribute('aria-label', guestLabel);

    var longLabel = tab.querySelector('.nuvra-header-tab__label--long');
    var shortLabel = tab.querySelector('.nuvra-header-tab__label--short');

    if (longLabel) {
      longLabel.textContent = guestLabel;
    } else if (tab.classList.contains('nuvra-site-header__drawer-link')) {
      tab.textContent = guestLabel;
    }

    if (shortLabel) {
      shortLabel.textContent = guestShort;
    }
  }

  function studioHandoffUrl(apiBase, path, authToken) {
    if (!authToken) return apiBase + path;
    var join = path.indexOf('?') >= 0 ? '&' : '?';
    return apiBase + path + join + 'handoff=' + encodeURIComponent(authToken);
  }

  function applyMemberHubTab(tab, hubUrl) {
    var memberLabel = tab.dataset.hubMemberLabel || tab.dataset.sellMemberLabel || 'Seller Hub';
    var memberShort = tab.dataset.hubMemberShort || tab.dataset.sellMemberShort || 'Hub';
    var memberHref = hubUrl || tab.dataset.hubMemberHref || tab.dataset.sellMemberHref || (resolveSellerApiBase(document.querySelector('.nuvra-site-header-wrap')) + '/seller/dashboard');
    tab.href = memberHref;
    tab.setAttribute('aria-label', memberLabel);

    var longLabel = tab.querySelector('.nuvra-header-tab__label--long');
    var shortLabel = tab.querySelector('.nuvra-header-tab__label--short');

    if (longLabel) {
      longLabel.textContent = memberLabel;
    } else if (tab.classList.contains('nuvra-site-header__drawer-link')) {
      tab.textContent = memberLabel;
    }

    if (shortLabel) {
      shortLabel.textContent = memberShort;
    }
  }

  function resolveSellerApiBase(wrap) {
    var apiBase = (wrap && wrap.dataset.sellerApi ? wrap.dataset.sellerApi : '').replace(/\/$/, '');
    if (!apiBase) {
      apiBase = 'https://admin-uploader-psi.vercel.app';
    }
    if (
      apiBase.indexOf('studio.nuvrasupplyco.com') >= 0 ||
      apiBase.indexOf('nuvra-studio.vercel.app') >= 0
    ) {
      apiBase = 'https://admin-uploader-psi.vercel.app';
    }
    return apiBase;
  }

  function yourShopListItem(tab) {
    var item = tab.closest('[data-nuvra-your-shop-item]');
    if (!item && tab.closest('.nuvra-site-header__drawer-list')) {
      item = tab.closest('li');
    }
    return item;
  }

  function setYourShopTabVisible(tab, visible) {
    var item = yourShopListItem(tab);
    if (visible) {
      tab.removeAttribute('hidden');
      if (item) item.removeAttribute('hidden');
    } else {
      tab.setAttribute('hidden', '');
      if (item) item.setAttribute('hidden', '');
    }
  }

  function hideYourShopTab(tab) {
    setYourShopTabVisible(tab, false);
  }

  function showYourShopTab(tab, shopUrl) {
    tab.href = shopUrl;
    tab.setAttribute('aria-label', 'Your Shop');

    var longLabel = tab.querySelector('.nuvra-header-tab__label--long');
    var shortLabel = tab.querySelector('.nuvra-header-tab__label--short');

    if (longLabel) {
      longLabel.textContent = 'Your Shop';
    } else if (tab.classList.contains('nuvra-site-header__drawer-link')) {
      tab.textContent = 'Your Shop';
    }

    if (shortLabel) {
      shortLabel.textContent = 'Shop';
    }

    setYourShopTabVisible(tab, true);
  }

  function hubTabs() {
    return document.querySelectorAll('[data-nuvra-seller-hub-tab], [data-nuvra-sell-tab]');
  }

  function yourShopTabs() {
    return document.querySelectorAll('[data-nuvra-your-shop-tab], [data-nuvra-shops-tab]');
  }

  function initSellerHubTab(wrap) {
    var apiBase = resolveSellerApiBase(wrap);
    var tabs = hubTabs();
    if (!tabs.length) return;

    function refreshHubTab() {
      var token = null;
      try {
        token = localStorage.getItem('nuvra_creator_token');
      } catch (_) {
        return;
      }

      if (!token || !apiBase) {
        tabs.forEach(function (tab) {
          applyGuestHubTab(tab, null);
        });
        return;
      }

      tabs.forEach(function (tab) {
        applyMemberHubTab(tab, studioHandoffUrl(apiBase, '/seller/dashboard', token));
      });
    }

    refreshHubTab();

    if (!wrap.dataset.hubTabBound) {
      wrap.dataset.hubTabBound = '1';
      window.addEventListener('nuvra:seller-auth-changed', refreshHubTab);
      window.addEventListener('storage', function (event) {
        if (event.key === 'nuvra_creator_token') {
          refreshHubTab();
        }
      });
    }
  }

  function initYourShopTab(wrap) {
    var apiBase = resolveSellerApiBase(wrap);
    var tabs = yourShopTabs();
    if (!tabs.length) return;

    tabs.forEach(hideYourShopTab);

    function refreshYourShopTab() {
      var token = null;
      try {
        token = localStorage.getItem('nuvra_creator_token');
      } catch (_) {
        return;
      }

      if (!token || !apiBase) {
        tabs.forEach(hideYourShopTab);
        return;
      }

      fetch(apiBase + '/api/seller/dashboard', {
        headers: { Authorization: 'Bearer ' + token },
      })
        .then(function (res) {
          if (!res.ok) {
            tabs.forEach(hideYourShopTab);
            return null;
          }
          return res.json();
        })
        .then(function (data) {
          if (!data || !data.profile || !data.profile.handle) {
            tabs.forEach(hideYourShopTab);
            return;
          }

          var shopUrl = '/?view=seller-shop&handle=' + encodeURIComponent(data.profile.handle);
          tabs.forEach(function (tab) {
            showYourShopTab(tab, shopUrl);
          });
        })
        .catch(function () {
          tabs.forEach(hideYourShopTab);
        });
    }

    refreshYourShopTab();

    if (!wrap.dataset.yourShopTabBound) {
      wrap.dataset.yourShopTabBound = '1';
      window.addEventListener('nuvra:seller-auth-changed', refreshYourShopTab);
      window.addEventListener('storage', function (event) {
        if (event.key === 'nuvra_creator_token') {
          refreshYourShopTab();
        }
      });
    }
  }

  function initHeader(wrap) {
    var menuBtn = wrap.querySelector('[data-nuvra-menu-open]');
    var drawer = wrap.querySelector('[data-nuvra-drawer]');
    if (!menuBtn || !drawer) return;

    var closeTriggers = drawer.querySelectorAll('[data-nuvra-drawer-close]');
    var panel = drawer.querySelector('.nuvra-site-header__drawer-panel');

    function openDrawer() {
      drawer.hidden = false;
      drawer.classList.add('is-open');
      menuBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.setAttribute('scroll-lock', '');
      if (panel) {
        panel.focus();
      }
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      menuBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.removeAttribute('scroll-lock');
      window.setTimeout(function () {
        if (!drawer.classList.contains('is-open')) {
          drawer.hidden = true;
        }
      }, 280);
    }

    menuBtn.addEventListener('click', openDrawer);

    closeTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', closeDrawer);
    });

    drawer.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
        menuBtn.focus();
      }
    });
  }

  function initDrawerLogout(wrap) {
    var btn = wrap.querySelector('[data-nuvra-drawer-logout]');
    if (!btn || wrap.dataset.logoutBound) return;
    wrap.dataset.logoutBound = '1';

    function refreshLogoutVisibility() {
      var hasSeller = false;
      try {
        hasSeller = Boolean(localStorage.getItem('nuvra_creator_token'));
      } catch (_) {
        hasSeller = false;
      }
      var hasCustomer = wrap.dataset.customerLoggedIn === '1';
      if (hasSeller || hasCustomer) {
        btn.removeAttribute('hidden');
      } else {
        btn.setAttribute('hidden', '');
      }
    }

    btn.addEventListener('click', function () {
      try {
        localStorage.removeItem('nuvra_creator_token');
        localStorage.removeItem('nuvra_seller_email');
      } catch (_) {
        /* ignore */
      }
      try {
        window.dispatchEvent(new CustomEvent('nuvra:seller-auth-changed'));
      } catch (_) {
        /* ignore */
      }

      var logoutUrl = wrap.dataset.accountLogoutUrl;
      if (wrap.dataset.customerLoggedIn === '1' && logoutUrl) {
        window.location.href = logoutUrl;
        return;
      }
      window.location.reload();
    });

    refreshLogoutVisibility();
    window.addEventListener('nuvra:seller-auth-changed', refreshLogoutVisibility);
    window.addEventListener('storage', function (event) {
      if (event.key === 'nuvra_creator_token') {
        refreshLogoutVisibility();
      }
    });
  }

  function migrateLegacyHeaderTabs(wrap) {
    var actions = wrap.querySelector('.nuvra-site-header__actions');
    if (!actions) return;

    actions.querySelectorAll('[data-nuvra-shops-tab]').forEach(function (tab) {
      if (!tab.hasAttribute('data-nuvra-your-shop-tab')) {
        tab.setAttribute('data-nuvra-your-shop-tab', '');
      }
    });

    actions.querySelectorAll('[data-nuvra-sell-tab]').forEach(function (tab) {
      if (!tab.hasAttribute('data-nuvra-seller-hub-tab')) {
        tab.setAttribute('data-nuvra-seller-hub-tab', '');
      }
    });
  }

  function migrateLegacyDrawerTabs(wrap) {
    var drawer = wrap.querySelector('[data-nuvra-drawer]');
    if (!drawer) return;

    drawer.querySelectorAll('a').forEach(function (link) {
      if (link.hasAttribute('data-nuvra-seller-shops-menu')) return;
      var text = (link.textContent || '').replace(/\s+/g, ' ').trim();
      if (text === 'Your Shop' && !link.hasAttribute('data-nuvra-your-shop-tab')) {
        link.setAttribute('data-nuvra-your-shop-tab', '');
        link.setAttribute('hidden', '');
      }
      if ((text === 'Seller Hub' || text === 'My Seller Hub') && !link.hasAttribute('data-nuvra-seller-hub-tab')) {
        link.setAttribute('data-nuvra-seller-hub-tab', '');
      }
    });
  }

  function hideLegacyHeaderRows() {
    var headerGroup = document.querySelector('#header-group');
    if (!headerGroup || !headerGroup.querySelector('.nuvra-site-header')) return;

    var css =
      '#header-group:has(.nuvra-site-header) .header-section,' +
      '#header-group:has(.nuvra-site-header) .header-section #header-component,' +
      '#header-group:has(.nuvra-site-header) .header-section .header__row,' +
      '#header-group:has(.nuvra-site-header) .header-section > .section-background,' +
      '#header-group:has(.nuvra-site-header) > .header-section,' +
      '#header-group:has(.nuvra-site-header) #header-component{display:none!important;visibility:hidden!important;' +
      'height:0!important;min-height:0!important;max-height:0!important;overflow:hidden!important;' +
      'margin:0!important;padding:0!important;border:0!important;pointer-events:none!important}';

    var style = document.getElementById('nuvra-hide-legacy-header-rows');
    if (!style) {
      style = document.createElement('style');
      style.id = 'nuvra-hide-legacy-header-rows';
      document.head.appendChild(style);
    }
    style.textContent = css;

    headerGroup
      .querySelectorAll('.header-section, #header-component, .header__row, .nuvra-mp-trust-section')
      .forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('height', '0', 'important');
        el.style.setProperty('max-height', '0', 'important');
        el.style.setProperty('overflow', 'hidden', 'important');
        el.style.setProperty('margin', '0', 'important');
        el.style.setProperty('padding', '0', 'important');
      });
  }

  function syncHeaderHeightVars() {
    var header = document.querySelector('.nuvra-site-header');
    var headerGroup = document.querySelector('#header-group');
    if (!header || !headerGroup) return;

    var height = Math.round(header.offsetHeight);
    var groupHeight = Math.round(headerGroup.offsetHeight);
    document.body.style.setProperty('--header-height', height + 'px');
    document.body.style.setProperty('--header-group-height', groupHeight + 'px');
    document.body.style.setProperty('--transparent-header-offset-boolean', '0');
  }

  function fixSellerShopsApiBase() {
    var mount = document.getElementById('nuvra-seller-shops-mount');
    if (!mount) return;

    var section = mount.closest('[data-api-base]');
    if (!section) return;

    var wrap = document.querySelector('.nuvra-site-header-wrap');
    section.setAttribute('data-api-base', resolveSellerApiBase(wrap));
  }

  function applyVolumePromo(wrap, data) {
    var header = wrap.querySelector('.nuvra-site-header');
    var promo = wrap.querySelector('[data-nuvra-volume-promo]');
    if (!header || !promo) return;

    var active = Boolean(data && data.active && data.percentOff > 0 && data.minQuantity > 0);
    var textNode = promo.querySelector('[data-nuvra-volume-promo-text]');
    if (active) {
      var text =
        data.bannerText ||
        'Buy ' + data.minQuantity + ' shirts, get ' + data.percentOff + '% off — automatic at checkout';
      if (textNode) textNode.textContent = text;
      promo.hidden = false;
      header.classList.add('nuvra-site-header--has-promo');
      wrap.setAttribute('data-volume-promo-pct', String(data.percentOff));
      wrap.setAttribute('data-volume-promo-qty', String(data.minQuantity));
    } else {
      promo.hidden = true;
      header.classList.remove('nuvra-site-header--has-promo');
      wrap.setAttribute('data-volume-promo-pct', '0');
    }
    syncHeaderHeightVars();
  }

  function initVolumePromo(wrap) {
    var apiBase = resolveSellerApiBase(wrap);
    if (!apiBase) return;

    fetch(apiBase + '/api/storefront/volume-discount', {
      credentials: 'omit',
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        if (!res.ok) throw new Error('volume discount fetch failed');
        return res.json();
      })
      .then(function (data) {
        applyVolumePromo(wrap, data);
      })
      .catch(function () {
        /* keep Liquid/metafield render */
      });
  }

  function boot() {
    fixSellerShopsApiBase();
    hideLegacyHeaderRows();
    syncHeaderHeightVars();
    ensureCollectionPageVisible();
    document.querySelectorAll('.nuvra-site-header-wrap').forEach(function (wrap) {
      migrateLegacyHeaderTabs(wrap);
      migrateLegacyDrawerTabs(wrap);
      initHeader(wrap);
      initYourShopTab(wrap);
      initSellerHubTab(wrap);
      initDrawerLogout(wrap);
      initVolumePromo(wrap);
    });
  }

  hideLegacyHeaderRows();
  fixSellerShopsApiBase();
  syncHeaderHeightVars();

  if (typeof MutationObserver !== 'undefined' && document.documentElement) {
    var headerObserverScheduled = false;
    new MutationObserver(function () {
      if (headerObserverScheduled) return;
      headerObserverScheduled = true;
      window.requestAnimationFrame(function () {
        headerObserverScheduled = false;
        hideLegacyHeaderRows();
        syncHeaderHeightVars();
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
